import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

window.__REMIMINDER_BUILD = "v2026-04-22-mailing-v4-dual";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
